module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": "true",
      "useIcon": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "count-wrap"
  }, [_c('div', {
    staticClass: "count-inner"
  }, [_c('div', {
    staticClass: "count-text"
  }, [_vm._v("摄入总热量")]), _vm._v(" "), _c('countTo', {
    staticClass: "count-num",
    attrs: {
      "separator": _vm.theseparator,
      "startVal": _vm.startVal,
      "endVal": _vm.endVal,
      "duration": 2000
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "count-text"
  }, [_vm._v("卡路里")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "chose-wrap"
  }, [_c('h3', [_vm._v("请选择体重与运动")]), _vm._v(" "), _c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.selectWeight()
      }
    }
  }, [_c('div', {
    staticClass: "icon-weight"
  }, [_vm._v("您的体重")]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-right"
  }, [(_vm.defaultWeight) ? _c('span', [_vm._v(_vm._s(_vm.defaultWeight) + "kg")]) : _vm._e()])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.selectMotion()
      }
    }
  }, [_c('div', {
    staticClass: "icon-motion"
  }, [_vm._v("选择运动")]), _vm._v(" "), _c('div', {
    staticClass: "icon-arrow-right motion"
  }, [_vm._v(_vm._s(_vm.defaultMotion))])])])]), _vm._v(" "), _c('div', {
    staticClass: "calculate-link",
    on: {
      "click": function($event) {
        _vm.goresult()
      }
    }
  }, [_vm._v("计算运动方案时长")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8b2b4cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/chosemotion.vue
// module id = 151
// module chunks = 1